import Route from './blog-routes'
import Tile from './components/blog-post-tile'
import Details from './connected/blog-post-connected'

export { Tile, Details, Route }
export default { Tile, Details, Route }
